export default class CustomSelect {
  constructor(customSelectsContainer) {
    this.element = customSelectsContainer
    this.select = customSelectsContainer.querySelector("select")
    this.options = customSelectsContainer.querySelectorAll("option")
    this.init();
  }

  init() {
    const self = this;
    let selectedContainer;
    let i;
    /**
     * for each element, create a new DIV that will act as the selected item:
     */
    selectedContainer = document.createElement("DIV");
    selectedContainer.setAttribute("class", "select-selected");
    selectedContainer.innerHTML = self.options[self.select.selectedIndex].innerHTML;
    self.element.appendChild(selectedContainer);
    /* for each element, create a new DIV that will contain the option list: */
    let optionsContainer = document.createElement("DIV");
    optionsContainer.setAttribute("class", "select-items select-hide");

    for (i = 1; i < self.options.length; i++) {
      let customOption;
      /**
       * for each option in the original select element,
       * create a new DIV that will act as an option item:
       */
      customOption = document.createElement("DIV");
      customOption.innerHTML = self.options[i].innerHTML;
      customOption.addEventListener("click", ({target}) => {
        /**
         * when an item is clicked, update the original select box,
         * and the selected item:
         */
        let sameAsSelected;
        let previousSibling;
        let j;
        let k;
        previousSibling = target.parentNode.previousSibling;
        for (j = 0; j < self.options.length; j++) {
          if (self.options[j].innerHTML === target.innerHTML) {
            self.element.selectedIndex = j;
            previousSibling.innerHTML = target.innerHTML;
            sameAsSelected = target.parentNode.querySelectorAll(".same-as-selected");
            for (k = 0; k < sameAsSelected.length; k++) {
              sameAsSelected[k].removeAttribute("class");
            }
            target.setAttribute("class", "same-as-selected");
            break;
          }
        }
        previousSibling.click();
      });
      optionsContainer.appendChild(customOption);
    }
    self.element.appendChild(optionsContainer);
    selectedContainer.addEventListener("click", event => {
      /**
       *  when the select box is clicked, close any other select boxes,
       *  and open/close the current select box:
       */
      event.stopPropagation();
      self.closeAllSelect(event.target);
      event.target.nextSibling.classList.toggle("select-hide");
      event.target.classList.toggle("select-arrow-active");
    });
    self.bindThisInstance();
  }

  closeAllSelect() {
    const self = this;
    /*a function that will close all select boxes in the document,
    except the current select box:*/
    let selectItems;
    let selected;
    let i;
    const arrNo = [];
    selectItems = document.querySelectorAll(".select-items");
    selected = document.querySelectorAll(".select-selected");
    for (i = 0; i < selected.length; i++) {
      if (self.element === selected[i]) {
        arrNo.push(i)
      } else {
        selected[i].classList.remove("select-arrow-active");
      }
    }
    for (i = 0; i < selectItems.length; i++) {
      if (arrNo.indexOf(i)) {
        selectItems[i].classList.add("select-hide");
      }
    }
  }

  bindThisInstance() {
    const self = this;
    document.addEventListener("click", self.closeAllSelect);
  }
}
